import React from "react";
import { RouterProvider } from "react-router-dom";

import { router } from "./routes";
import { QueryProvider } from "./shared/providers/QueryProvider";
import { ThemeProvider } from "./shared/context";

const App: React.FC = () => (
  <QueryProvider>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </QueryProvider>
);

export default App;
